import DashboardProfile from '../components/DashboardProfile/DashboardProfile';
import DashboardUsersTable from "../components/DashboardUserTable/DashboardUsersTable.js"
import styles from './Dashboard.module.scss';

const Dashboard = () => {
  return (
    <div className={styles['dashboard-container']}>
      <DashboardProfile />
      <DashboardUsersTable />
    </div>
  );
};

export default Dashboard;
